import React, { useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from '@material-ui/icons/Search';
import MediaQuery from "react-responsive";


const styles = makeStyles((theme) => ({
  inputArea: {
    display: 'flex',
    alignItems: 'center',
  },
  /* barIcon */
  barIcon: {
    width: "44px",
    height: "44px",
    marginRight: "7px",
  },
  inputInput: {
    position: 'relative',
    right: '-40px',
    height: '32px',
    width: '32px',
    borderRadius: '18px',
    backgroundColor: 'inherit',
    border: '0px',
    transition: 'width 0.5s, background-color 0.5s',
    '&:focus': {
      width: '240px',
      height: '32px',
      backgroundColor: '#ffffff',
      padding: '0em 1em 0em 1em',
      outline: '0',
    },
  },
  inputInputmin: {
    position: 'relative',
    right: '-40px',
    height: '32px',
    width: '32px',
    borderRadius: '18px',
    backgroundColor: 'inherit',
    border: '0px',
    transition: 'width 0.5s, background-color 0.5s',
    '&:focus': {
      width: '170px',
      height: '32px',
      backgroundColor: '#ffffff',
      padding: '0em 1em 0em 1em',
      outline: '0',
    },
  },
  inputInputpopup: {
    position: 'absolute',
    zIndex: '2',
    right: '20px',
    top: '50px',
    height: '32px',
    width: '32px',
    borderRadius: '18px',
    backgroundColor: 'inherit',
    border: '2px solid',
    transition: 'width 0.5s, background-color 0.5s',
    '&:focus': {
      width: '170px',
      height: '32px',
      backgroundColor: '#ffffff',
      padding: '0em 1em 0em 1em',
      border: '2px solid #333333',
    },
  },
}))

function Searchbox(props) {
  const classes = styles();
  const { iconSize, color } = props;
  let [searchbox, setsearchbox] = useState(false);
  let [searchText, setsearchText] = useState("");

  // 検索実行
  const clickSearch = () => {
    if (searchText === "") {
      setsearchbox(!searchbox);
    } else {
      window.location.href = "/search?mode=search&q=" + searchText;
    }
  };
  const clickSearchbox = () => {
    if (searchText === "") {
      setsearchbox(false);
    } else {
      setsearchbox(true);
    }
  };
  const changeSearch = (e) => {
    if (e.target.value !== "") {
      setsearchText(e.target.value);
      setsearchbox(true);
    } else {
      setsearchText(e.target.value);
      setsearchbox(false);
    }
  };

  // エンターを押したとき検索実行
  const handlekeydown = (e) => {
    if (e.keyCode === 13) {
      // エンターキーが押されたとき
      if (searchText === "") {
        e.preventDefault();
      } else {
        window.location.href = "/search?mode=search&q=" + searchText;
      }
    }
  }

  const popupinput = (
    <input
      className={classes.inputInputpopup}
      onChange={changeSearch}
      onClick={clickSearchbox}
      onKeyDown={handlekeydown}
      placeholder={searchbox? "キーワードやひとを検索": ""}
      style={searchbox?
          {backgroundColor: '#ffffff', border: '2px solid', padding: '0em 1em 0em 1em', width: "170px", height: '32px'}
        : {border: '0'}
      }
    />
  )

  return (
    <>
      <MediaQuery query="(max-width: 700px)">
        <div className={classes.inputArea}>
          <MediaQuery query="(min-width: 601px)">
            <input
              className={classes.inputInputmin}
              onChange={changeSearch}
              onClick={clickSearchbox}
              onKeyDown={handlekeydown}
              placeholder={searchbox? "キーワードやひとを検索": ""}
              style={searchbox?
                  {backgroundColor: '#ffffff', padding: '0em 1em 0em 1em', width: "170px", height: '32px'}
                : {}
              }
            />
          </MediaQuery>
          <MediaQuery query="(max-width: 600px)">
            {popupinput}
          </MediaQuery>
          <IconButton className={classes.barIcon} onClick={clickSearch}>
            <SearchIcon />
          </IconButton>
        </div>
      </MediaQuery>
      <MediaQuery query="(min-width: 701px)">
        <div className={classes.inputArea}>
          <input
            className={classes.inputInput}
            onChange={changeSearch}
            onClick={clickSearchbox}
            onKeyDown={handlekeydown}
            placeholder={searchbox? "キーワードやひとを検索": ""}
            style={searchbox?
                {backgroundColor: '#ffffff', padding: '0em 1em 0em 1em', width: "240px", height: '32px'}
              : {}
            }
          />
          <IconButton className={classes.barIcon} onClick={clickSearch}>
            <SearchIcon style={{height: iconSize, width: iconSize, color: color}} />
          </IconButton>
        </div>
      </MediaQuery>
    </>
  )
}

export default Searchbox;
